import { render } from "./Bill.vue?vue&type=template&id=b2aaece4&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=ts"
export * from "./Bill.vue?vue&type=script&lang=ts"

import "./Bill.vue?vue&type=style&index=0&id=b2aaece4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b2aaece4"

export default script